module.exports = __webpack_public_path__ + "media/images/pay3_color_mobile-7da333a06ddcd8ddaf24fdab347e94e4.svg";